import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { HERO_STATS } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * Hero de KETO 4P. El mockup oficial es el protagonista visual y el elemento
 * LCP: se muestra completo, sin recortes ni textos encima.
 */
export function Hero() {
  return <section className="warm-halo relative w-full overflow-hidden border-b border-line" data-id="element-115" data-mp="12a0it4iflorg">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 pb-14 pt-10 sm:px-8 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-20" data-id="element-116" data-mp="x9upzl0fdw7s">
        {/* Copy */}
        <div className="animate-hero-copy order-2 lg:order-1" data-id="element-117" data-mp="ncgkuhjyctus">
          <p className="font-display text-[0.68rem] uppercase tracking-editorial text-gold" data-id="element-118" data-mp="nbydopvr4v83">
            Keto 4P · Panes · Pizzas · Pastas · Postres
          </p>

          <h1 className="mt-4 font-condensed text-[2.6rem] uppercase leading-[0.92] text-bone sm:text-6xl lg:text-[4.15rem]" data-id="element-119" data-mp="381e2jfbeu9v3">
            500 recetas keto para comer{' '}
            <span className="text-glow-gold" data-id="element-120" data-mp="3o7c05xxxspgm">rico, variado y sin culpa</span>
          </h1>

          <p className="mt-5 max-w-xl text-[1.02rem] leading-relaxed text-ash sm:text-lg" data-id="element-121" data-mp="39acuwgqk58pb">
            Panes, pizzas, pastas y postres keto para que mantenerte en cetosis deje de significar
            comer siempre lo mismo.
          </p>

          {/* 6 TOMOS · 500 RECETAS · 5 BONOS */}
          <dl className="mt-7 grid grid-cols-3 overflow-hidden rounded-xl border border-gold/25 bg-gold/[0.06]" data-id="element-122" data-mp="358rckfv9827q">
            {HERO_STATS.map((stat, index) => <div key={stat.etiqueta} className={`px-3 py-4 text-center ${index > 0 ? 'border-l border-gold/20' : ''}`} data-id="element-123" data-mp="2qleqmq1jbugt" data-mpi={index}>
                <dt className="font-condensed text-3xl leading-none text-gold sm:text-4xl" data-id="element-124" data-mp="2hix224yeqpqn">
                  {stat.valor}
                </dt>
                <dd className="mt-1.5 font-display text-[0.55rem] uppercase leading-tight tracking-editorial text-bone/75" data-id="element-125" data-mp="2lmv0sejtlyj6">
                  {stat.etiqueta}
                </dd>
              </div>)}
          </dl>

          <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-126" data-mp="ic891hh2wayw">
            <CTAButton data-id="element-127" data-mp="i9vqb23hxwks" />
            <PriceBlock size="sm" layout="inline" data-id="element-128" data-mp="ddf0m3gnfa5l" />
          </div>

          <p className="mt-3 text-[0.78rem] text-ash" data-id="element-129" data-mp="db2erf7rsfn9">
            Acceso digital · Pago único · Lo abrís en el celular
          </p>

          <TrustStrip className="mt-7 border-t border-line pt-6" data-id="element-130" data-mp="161ayvclv9a4h" />
        </div>

        {/* Mockup oficial */}
        <div className="animate-hero-media order-1 lg:order-2" data-id="element-131" data-mp="111yb8pn67z0u">
          <img src={HERO_IMAGE_URL} alt="KETO 4P: los 6 tomos digitales con 500 recetas de panes, pizzas, pastas y postres, más los 5 bonos exclusivos" width={1087} height={1449} fetchPriority="high" decoding="async" className="mx-auto w-full max-w-[520px] rounded-xl shadow-[0_40px_120px_-45px_rgba(255,196,0,0.45)]" data-id="element-132" data-mp="x14ow0pdmsa2" />
        </div>
      </div>
    </section>;
}